import en from "./en";
import zh from "./zh";
import { createIntl } from "react-intl";
import { store } from "../app/store";

const messages = {
  en,
  zh,
};

function getIntlMessages(language = "en") {
  let currentMessages = messages[language] || {};
  let pageMessages = Object.assign(
    {},
    currentMessages["common"],
    currentMessages["footer"],
    currentMessages["home"],
    currentMessages["nav_modal_data"],
    currentMessages["carousel_data"],
    currentMessages["usecase_data"],
    currentMessages["pos_devices_data"],
    currentMessages["software_data"],
    currentMessages["acquire_customer_data"],
    currentMessages["clover_flex_data"],
    currentMessages["clover_mini_data"],
    currentMessages["clover_station_duo_data"],
    currentMessages["clover_station_solo_data"],
    currentMessages["kitchen_display_system_data"],
    currentMessages["self_service_kiosk_data"],
    currentMessages["hardware_data"],
    currentMessages["online_brand_data"],
    currentMessages["auto_order_data"],
    currentMessages["roboto_bellabot_data"],
    currentMessages["footer_banner"],
    currentMessages["faq"],
    currentMessages["about"],
    currentMessages["careers"],
    currentMessages["pricing"],
    currentMessages["blog_list"],
    currentMessages["features"],
    currentMessages["contact"],
    currentMessages["signup"],
    currentMessages["promobot"],
    currentMessages["bellabot"],
    currentMessages["flashbot"],
    currentMessages["disinfectionbot"],
    currentMessages["pudubot"],
    currentMessages["robots_common"],
    currentMessages["use_case_pages"],
    currentMessages["use_case_kiosk"],
    currentMessages["browser_pos_devices"],
    currentMessages["browser_by_use_cases"],
    currentMessages["browser_by_use_case"],
    currentMessages["service_rates"],
    currentMessages["service_rate_title"],
    currentMessages["service_rate_data"],
    currentMessages["service_rates_faq_data"],
    currentMessages["service_rates_industry_faq_data"],
    currentMessages["select_your_industry"],
    currentMessages["terms_and_conditions"],
    currentMessages["privacy_policy"],
    currentMessages["request_free_demo"],
    currentMessages["go_digital"],
    currentMessages["techup"],
    currentMessages["grants"],
    currentMessages["pricing_base"],
    currentMessages["clover_application"],
    currentMessages["commercial_equipment_lease"],
  );
  return pageMessages;
}

export function getIntl() {
  const state = store.getState();
  const { lan = "en" } = state?.settings ?? {};

  return createIntl({ locale: lan, messages: getIntlMessages(lan) });
}

export default {
  getIntlMessages,
};
